module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "c-card"
  }, [_c('header', {
    staticClass: "c-card__header"
  }, [_c('div', {
    staticClass: "c-card__leading"
  }, [_c('h6', {
    staticClass: "c-card__title"
  }, [_vm._v(_vm._s(_vm.definitionModule.name))]), _vm._v(" "), _c('span', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.$t(_vm.definitionModule.type).label))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__control"
  }, [_c('button', {
    staticClass: "btn btn--smart btn--sm",
    class: _vm.buttonClass,
    attrs: {
      "href": "#",
      "disabled": _vm.definitionModule.module || _vm.installing
    },
    on: {
      "click": _vm.installModule
    }
  }, [_vm._v("\n        " + _vm._s(_vm.definitionModule.module ? 'Instalado' : 'Instalar') + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-341adbbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/StoreCardTool.vue
// module id = 3042
// module chunks = 0